import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const BASE = {
  name: 'base',
  chainId: 8453,
  averageBlockTimeSeconds: 2,
  explorerUrl: 'https://basescan.org',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x4200000000000000000000000000000000000006',
  blockscoutApiUrl: 'https://base.blockscout.com/api',
  etherscanSupported: true,
  publicRpcUrls: ['https://mainnet.base.org', 'https://1rpc.io/base', 'https://base.drpc.org'],
  getPrivateRpcUrls: () => {
    const base: string[] = []
    process.env.ROUTEME_API_KEY && base.push(`https://lb.routeme.sh/rpc/8453/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('base')
    quickNodeUrl && base.push(quickNodeUrl)
    process.env.INFURA_API_KEY && base.push(`https://base-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    process.env.ALCHEMY_API_KEY && base.push(`https://base-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    process.env.ANKR_API_KEY && base.push(`https://rpc.ankr.com/base/${process.env.ANKR_API_KEY}`)
    return base
  },
} as const satisfies ChainConfig
